import { createAction } from 'redux-actions';
import uuid from 'uuid/v4';

import { getPrimus } from '../../utils/primus';
import { getStore } from '../../store/helpers';
import { CLIENT_ORIGIN_WS_EVENTS } from '~/constants';

export const setTemplates = createAction('app/SET_TEMPLATES');

export const createTemplate = createAction('app/CREATE_TEMPLATE', (data) => {
  const store = getStore();
  const primus = getPrimus();

  const {
    user: { id: user_id },
  } = store.getState();

  const payload = { id: uuid(), user_id, ...data };

  primus.emit(
    CLIENT_ORIGIN_WS_EVENTS.COLLECTION,
    { cid: 'templates' },
    payload
  );

  return payload;
});

export const deleteTemplate = createAction('app/DELETE_TEMPLATE');
